export enum AnalyticsEvent {
  ExtensionIconClick = 'CoachBot Extension: Icon Click',
  GetReward = 'CoachBot Extension: Get Reward',
  LinkClick = 'CoachBot Extension: Link Click',
  SignIn = 'CoachBot Extension: Sign In',
  // Debug events
  ServiceWorkerInitialized = 'CoachBot Extension: Service Worker Initialized',
}
